import { render } from "./Summary.vue?vue&type=template&id=f39589b0&scoped=true&ts=true"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"

import "./Summary.vue?vue&type=style&index=0&id=f39589b0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39589b0"]])

export default __exports__